import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '../redux/store/store';
import { PreferencesProvider, applyStoredTheme } from '../theme/PreferencesContext';
import { App } from './../app/App';
import './../styles/style.css';

const rootElement = document.getElementById('app');

if (!rootElement) {
  throw new Error('Root element #app not found');
}

// Before React renders: paint the stored theme and language onto <html> so the
// first frame is already dark for someone who chose dark. Doing it inside the
// provider instead would paint light first and flip on the next tick.
applyStoredTheme();

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      {/* Inside <Provider> — preferences are synced to the user's account via
          RTK Query, so they need the store. */}
      <PreferencesProvider>
        <App />
      </PreferencesProvider>
    </Provider>
  </React.StrictMode>,
);
